import { AnalysisGrainForm } from '@/features/loads/components/analysis-grain';

export const AnalysisGrainPage = () => {
  return <AnalysisGrainForm />;
};
